module.exports = __webpack_public_path__ + "static/5-stars-98aceb298f0e6315c3ff882e0cb3c331.png";